import React from "react";
import { CiHeart } from "react-icons/ci";
import "../Shopidy/ProductView.css";
const SingleProduct = (item, index, LoginAccount, Setlogin) => {
  console.log(item?.item.name, "qqqq");
  return (
    <>
      <div className="product-item">
        <div className="product-wish-icon">
          {item?.item?.available && (
            <CiHeart
              productId={item.id}
              LoginAccount={LoginAccount}
              Setlogin={Setlogin}
            />
          )}
        </div>
        {/* {item?.item?.discount_percentage > 0 && (
          <div class="discount_icon_container">
            <div class="discount_percentage">
              {item?.item?.discount_percentage}% OFF
            </div>
          </div>
        )} */}
        {item?.item?.available ? (
          <div className="product-img">
            <img
              src={
                item?.item?.image ? item?.item?.image.image : item?.item?.image
              }
              alt={item?.item?.name}
            />
          </div>
        ) : (
          <div className="product-img">
            <img
              src={
                item?.item?.image ? item?.item?.image.image : item?.item?.image
              }
              alt={item?.item?.name}
            />
          </div>
        )}

        {item?.item?.available ? (
          <p className="name">{item?.item?.name}</p>
        ) : (
          <p className="name">{item?.item?.name}</p>
        )}

        <div className="product-actions">
          <div className="p-price">
            {item?.item?.offer_price && item?.item?.offer_price > 0 ? (
              <>
                <p className="price">₹{item?.item?.offer_price}</p>
                <p
                  className={item?.item?.offer_price ? "produc-price" : "price"}
                >
                  ₹{item?.item?.price}
                </p>
              </>
            ) : (
              <p className="price">₹{item?.item?.price}</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export { SingleProduct };
